import { StateCreator } from 'zustand'

const vehiclePhotoDialogInitialState = {
  header: '',
  open: false,
  message: '',
}

export interface VehiclePhotoDialogSlice {
  vehiclePhotoDialog: typeof vehiclePhotoDialogInitialState
  setVehiclePhotoDialog: (
    payload: typeof vehiclePhotoDialogInitialState
  ) => void
}

const createVehiclePhotoDialogSlice: StateCreator<VehiclePhotoDialogSlice> = (
  set
) => ({
  vehiclePhotoDialog: vehiclePhotoDialogInitialState,
  setVehiclePhotoDialog: (payload) => {
    set(() => ({
      vehiclePhotoDialog: payload,
    }))
  },
})

export default createVehiclePhotoDialogSlice
